import axios from "axios";
import qs from "qs";

const service = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "/api"
      : "http://122.112.172.47:8001"
});

class HTTP {
  get(url, params) {
    return service.get(url, {
      params
    });
  }
  post(url, params) {
    return service.post(url, qs.stringify(params));
  }
}

export default HTTP;
